export class Filter {
    value: any;
    title: string;
    checked = false;
}



// WEBPACK FOOTER //
// ./src/app/entities/filter.ts